import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from '../ActivityFeed.styled';
import { AddCommentModal } from './AddCommentModal';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Comment button triggers a modal.
 */
export const CommentButton = _ref => {
  let {
    cssCommentButtonBackgroundColor,
    cssCommentButtonBorderRadius,
    cssCommentButtonBorderWidth,
    cssCommentButtonBorderColor,
    cssCommentButtonTextColor,
    loggedInMember,
    onLogin
  } = _ref;
  const {
    t
  } = useTranslation('blocks.activityFeed');
  return /*#__PURE__*/_jsx(AddCommentModal, {
    renderTrigger: referenceProps => /*#__PURE__*/_jsx(Styled.CommentButton, {
      "data-id": "cp-activity-feed-add-comment",
      cssCommentButtonBackgroundColor: cssCommentButtonBackgroundColor,
      cssCommentButtonBorderRadius: cssCommentButtonBorderRadius,
      cssCommentButtonBorderWidth: cssCommentButtonBorderWidth,
      cssCommentButtonBorderColor: cssCommentButtonBorderColor,
      cssCommentButtonTextColor: cssCommentButtonTextColor,
      ...referenceProps,
      children: t('ActivityFeed.CommentButton.label', 'Comment')
    }),
    loggedInMember: loggedInMember,
    onLogin: onLogin
  });
};